module.exports = __webpack_public_path__ + "static/people_pop27-cfc79086be3c9c3a4b311fb0ce48044c.png";